__turbopack_context__.v({
  "blueDot": "us7xnG_blueDot",
  "categoryItem": "us7xnG_categoryItem",
  "categoryNav": "us7xnG_categoryNav",
  "categoryText": "us7xnG_categoryText",
  "separator": "us7xnG_separator",
  "sidebar": "us7xnG_sidebar",
  "sidebarDescription": "us7xnG_sidebarDescription",
  "sidebarHeader": "us7xnG_sidebarHeader",
  "sidebarTitle": "us7xnG_sidebarTitle",
});
